import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCookie } from '../utilities/cookieHelper'; // Import the cookie helper

// Function to check if the user is authenticated
const isAuthenticated = () => {
  const token = getCookie('accessToken'); // Read 'accessToken' from cookies
  return !!token; // Returns true if token exists, false otherwise
};

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    // User not authenticated, redirect to SSO login page
    // Preserve the current location to redirect back after login
    // Note: The SSO redirect URL and mechanism might need adjustment based on clikkle.com's specifics
    const ssoLoginUrl = `https://accounts.clikkle.com/?redirect=${encodeURIComponent(window.location.origin + location.pathname + location.search)}`;
    window.location.href = ssoLoginUrl; // Perform the redirect
    return null; // Render nothing while redirecting
  }

  return children; // User is authenticated, render the requested component
};

export default ProtectedRoute; 